import React from "react";
import { ChevronLeft, ChevronRight } from "../../Auditoria/Helper/Icons";
import { MONTHS_ES, DAYS_ES } from "./Helper/calendarioUtils";
import "../../../Styles/RedesSociales/_RSMiniCalendario.scss";

// Mini-calendario para elegir los días de publicación, usado por los modales de Imágenes y Reels
export const RSMiniCalendario = ({ dias }) => {
    const {
        calYear, calMonth, calCells, diasSeleccionados,
        prevMonth, nextMonth, isToday, isDaySelected, isDayOriginal, isPastDay, toggleDay
    } = dias;

    return (
        <div className="rs-mini-cal">
            <div className="rs-mini-cal__toolbar">
                <button className="rs-cal-nav__btn" onClick={prevMonth}><ChevronLeft /></button>
                <span className="rs-mini-cal__label">{MONTHS_ES[calMonth]} {calYear}</span>
                <button className="rs-cal-nav__btn" onClick={nextMonth}><ChevronRight /></button>
            </div>

            <div className="rs-mini-cal__grid">
                {DAYS_ES.map(d => (
                    <div key={d} className="rs-mini-cal__header">{d}</div>
                ))}
                {calCells.map((cell, i) => {
                    const esPasado = cell.current && isPastDay(cell) && !isDaySelected(cell);
                    return (
                        <div
                            key={i}
                            className={`rs-mini-cal__cell
                                ${!cell.current ? "other-month disabled" : ""}
                                ${esPasado ? "disabled" : ""}
                                ${isToday(cell) ? "today" : ""}
                                ${isDaySelected(cell) ? "selected" : ""}
                                ${isDayOriginal(cell) && !isDaySelected(cell) ? "removed" : ""}
                            `}
                            onClick={() => toggleDay(cell)}
                        >
                            {cell.day}
                        </div>
                    );
                })}
            </div>

            {diasSeleccionados.length > 0 && (
                <div className="rs-mini-cal__selected-label">
                    {diasSeleccionados.length} día{diasSeleccionados.length > 1 ? "s" : ""} seleccionado{diasSeleccionados.length > 1 ? "s" : ""}
                </div>
            )}
        </div>
    );
};

export default RSMiniCalendario;